import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import './style.css'
import App from './App.vue'
import './style.css'
import './fontsize/icon.css'
import 'element-plus/dist/index.css'
import './styles/element-global.less'
import ElementPlus from 'element-plus'
import { ElMessage } from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import router from './router/router'
import GlobalPagination from './components/GlobalPagination'
import { initGlobalClearable } from './utils/globalClearable'

console.log(import.meta.env.VITE_APP_ENV, '环境');

// 创建 Pinia 实例并配置持久化插件
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

const app = createApp(App)
app.directive('global-click', {
    // 元素挂载前执行
    beforeMount(el, binding) {
        // 获取元素原始的@click处理函数
        const originalHandler = binding.value;
        // 创建包裹函数
        el._clickHandler = (e: any) => {
            let data = localStorage.getItem('userinfo')
            if (!data) return;
            let newdata = JSON.parse(data)
            // 权限判断示例
            if (newdata.status !== 1) {
                ElMessage.warning('请先填写企业认证信息')
                e.stopPropagation(); // 阻止事件冒泡
                return;
            } else {
                // 执行原始处理函数
                console.log('触发了全局点击事件');
                originalHandler(e);
            }
            // 公共处理逻辑
            // logClickEvent(el);
        };
        // 绑定新的事件监听
        el.addEventListener('click', el._clickHandler);
    },
    // 元素卸载时清理
    unmounted(el) {
        el.removeEventListener('click', el._clickHandler);
    }
});

// 全局配置：自动为所有 el-input 启用 clearable
// app.config.globalProperties.$ELEMENT = {
//   size: 'default',
//   // 设置 input 组件的默认属性
// }

// // 创建一个简单的 mixin 来处理 clearable 功能
// app.mixin({
//   data() {
//     return {
//       // 全局默认启用 clearable
//       defaultClearable: true
//     }
//   }
// })

// 挂载路由
app.use(router)
// 全局配置 ElementPlus，为所有 el-input 启用 clearable
app.use(ElementPlus, {
  locale: zhCn,
  // 全局配置
  size: 'default',
  // 可以在这里添加更多全局配置
})
app.use(pinia)
// 全局注册分页器组件
app.component('GlobalPagination', GlobalPagination)

// 初始化全局 clearable 功能
// initGlobalClearable()

app.mount('#app')

